import { render, staticRenderFns } from "./CustomDetail.vue?vue&type=template&id=43c0875c&"
import script from "./CustomDetail.vue?vue&type=script&lang=js&"
export * from "./CustomDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports